import { getKeyByValue } from './tabMapping'

interface ITDKParams {
  series_name?: string
  page?: number
  total_count?: number
  currentTab?: string
}

function tdk({
  series_name = '',
  page = 1,
  total_count,
  currentTab,
}: ITDKParams) {
  let title = ''
  let description = ''
  let keywords = ''
  if (currentTab === 'dongtai') {
    title = `${series_name}车友圈大全_${series_name}车友圈怎么样_懂车帝`
    description = `懂车帝${series_name}车友圈为您提供最全的${series_name}车友圈大全，涵盖${series_name}车友圈怎么样，${series_name}车友圈好不好，${series_name}车友圈怎么找等信息，想了解更多关于${series_name}车友圈信息就来懂车帝。`
    keywords = `${series_name}车友圈,${series_name}车友圈大全,${series_name}车友圈怎么样`
    // if (community_type === 0) {
    //   title = `${series_name}车友圈大全_${series_name}车友圈怎么样_懂车帝`
    //   description = `懂车帝${series_name}车友圈为您提供最全的${series_name}车友圈大全，涵盖${series_name}车友圈怎么样，${series_name}车友圈好不好，${series_name}车友圈怎么找等信息，想了解更多关于${series_name}车友圈信息就来懂车帝。`
    //   keywords = `${series_name}车友圈,${series_name}车友圈大全,${series_name}车友圈怎么样`
    // } else if (community_type === 9) {
    //   //官方
    //   title = `${city_name}官方车友圈大全_${city_name}官方车友圈怎么样_懂车帝`
    //   description = `懂车帝${city_name}官方车友圈为您提供最全的{${city_name}官方车友圈大全，涵盖${city_name}官方车友圈怎么样，${city_name}官方车友圈好不好，${city_name}官方车友圈怎么找等信息，想了解更多关于${city_name}官方车友圈信息就来懂车帝。`
    //   keywords = `${city_name}官方车友圈,${city_name}官方车友圈大全,${city_name}官方车友圈怎么样样`
    // } else if (community_type === 8) {
    //   //星级
    //   title = `${series_name}_懂车帝`
    //   description = `懂车帝${series_name}为您提供最全的${series_name}大全，涵盖${series_name}怎么样，${series_name}好不好，${series_name}怎么找等信息，想了解更多关于${series_name}信息就来懂车帝。`
    //   keywords = `${series_name},${series_name}怎么样,${series_name}好不好`
    // } else if (city_name) {
    //   //有地域
    //   title = `${city_name}${series_name}车友圈大全_${city_name}${series_name}}车友圈怎么样_懂车帝`
    //   description = `懂车帝${city_name}${series_name}车友圈为您提供最全的${city_name}${series_name}车友圈大全，涵盖${city_name}${series_name}车友圈怎么样，${city_name}${series_name}车友圈好不好，${city_name}${series_name}车友圈怎么找等信息，想了解更多关于${city_name}${series_name}车友圈信息就来懂车帝。`
    //   keywords = `${city_name}${series_name}车友圈,${city_name}${series_name}车友圈大全,${city_name}${series_name}车友圈怎么样`
    // } else {
    //   //其他
    //   title = `${avatar_user_name}车友圈_懂车帝`
    //   description = `懂车帝${avatar_user_name}车友圈为您提供最全的${avatar_user_name}车友圈大全，涵盖${avatar_user_name}车友圈怎么样，${avatar_user_name}车友圈好不好，${avatar_user_name}车友圈怎么找等信息，想了解更多关于${avatar_user_name}车友圈信息就来懂车帝。`
    //   keywords = `${avatar_user_name}车友圈,${avatar_user_name}车友圈怎么样,${avatar_user_name}车友圈好不好`
    // }
  } else {
    switch (currentTab) {
      case 'selected':
        title = `${series_name}车友圈精华帖_${series_name}论坛_${series_name}车友圈_懂车帝`
        description = `${series_name}车友圈群聚千万车友,为您提供众多${series_name}车友圈精华帖的内容，以车会友，尽在懂车帝。`
        keywords = `${series_name}车友圈精华帖,${series_name}论坛,${series_name}车友圈`
        break
      case 'hot':
        title = `${series_name}车友圈热门_${series_name}论坛_${series_name}车友圈_懂车帝`
        description = `${series_name}车友圈群聚千万车友,为您提供众多${series_name}车友圈热门论坛的内容，以车会友，尽在懂车帝。`
        keywords = `${series_name}车友圈热门,${series_name}论坛,${series_name}车友圈`
        break
      case 'price_discuss':
        title = `${series_name}车友圈价格讨论_${series_name}论坛_${series_name}车友圈_懂车帝`
        description = `${series_name}车友圈群聚千万车友,为您提供众多${series_name}车友圈价格讨论的内容，以车会友，尽在懂车帝。`
        keywords = `${series_name}车友圈价格讨论,${series_name}论坛,${series_name}车友圈`
        break
      case 'quality':
        title = `${series_name}车友圈质量反馈_${series_name}论坛_${series_name}车友圈_懂车帝`
        description = `${series_name}车友圈群聚千万车友,为您提供众多${series_name}车友圈质量反馈的内容，以车会友，尽在懂车帝。`
        keywords = `${series_name}车友圈质量反馈,${series_name}论坛,${series_name}车友圈`
        break
      case 'dakareyi':
        title = `${series_name}车友圈评车_${series_name}论坛_${series_name}车友圈_懂车帝`
        description = `${series_name}车友圈群聚千万车友,为您提供众多${series_name}车友圈评车的内容，以车会友，尽在懂车帝。`
        keywords = `${series_name}车友圈评车,${series_name}论坛,${series_name}车友圈`
        break
      case 'wenda':
        title = `${series_name}车友圈问答_${series_name}论坛_${series_name}车友圈_懂车帝`
        description = `${series_name}车友圈群聚千万车友,为您提供众多${series_name}车友圈问答交流平台，帮您排忧解难。以车会友，尽在懂车帝。`
        keywords = `${series_name}车友圈问答,${series_name}论坛,${series_name}车友圈`
        break
      case 'shangjia':
        title = `${series_name}车友圈商家_${series_name}论坛_${series_name}车友圈_懂车帝`
        description = `${series_name}车友圈群聚千万车友,为您提供众多${series_name}车友圈口碑的内容，以车会友，尽在懂车帝。`
        keywords = `${series_name}车友圈商家,${series_name}论坛,${series_name}车友圈`
        break
      default:
        title = `${series_name}车友圈${getKeyByValue(
          currentTab as any
        )}_${series_name}论坛_${series_name}车友圈_懂车帝`
        description = `${series_name}车友圈群聚千万车友,为您提供众多${series_name}车友圈${getKeyByValue(
          currentTab as any
        )}的内容，以车会友，尽在懂车帝。`
        keywords = `${series_name}车友圈${getKeyByValue(
          currentTab as any
        )},${series_name}论坛,${series_name}车友圈`
        break
    }
  }

  if (page > 1 && total_count) {
    title = `${title}_${page}/${Math.ceil(total_count / 30)}页_懂车帝`
    description = `${description}您当前浏览的是${series_name}车友圈商家内容第${page}页内容。`
    keywords = `${keywords},${page}/${Math.ceil(total_count / 30)}页`
  }

  return {
    title,
    description,
    keywords,
  }
}

export default tdk
